import React, { useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import MuPb from "../../widgets/MuPb";
import {
  Alert,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Box,
  Pagination,
  Container,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import {
  exportToExcel,
  getErrorResponse,
  getHeader,
  toastError,
} from "../../utils/util";
import { format } from "date-fns";
import PageTitle from "../../widgets/PageTitle";
import { LoadingButton } from "@mui/lab";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import TitleActionsContainer from "../../widgets/TitleActionsContainer";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import BackBtn from "../../widgets/BackBtn";

const TransactionHistory = () => {
  const [page, setPage] = useState(1);
  const [usageType, setUsageType] = useState("");
  const [exporting, setExporting] = useState(false);
  const { data, isLoading, isError, error } = useApiEp(
    `/user/my-transactions?page=${page}&type=${usageType}`
  );

  if (isLoading) {
    return <MuPb />;
  }

  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }

  const formatDate = (dateString) => {
    try {
      return format(new Date(dateString), "PPpp");
    } catch {
      return "Invalid Date";
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Container sx={{ mt: 3 }}>
      <TitleActionsContainer>
        <PageTitle>My Usage History</PageTitle>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          <FormControl size="small" sx={{ width: 240 }} fullWidth>
            <InputLabel id="demo-simple-select-label">Usage Type</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={usageType}
              label="Usage Type"
              onChange={(e) => setUsageType(e.target.value)}
            >
              <MenuItem value={""}>
                <i>None</i>
              </MenuItem>
              <MenuItem value={"usage"}>Usage</MenuItem>
              <MenuItem value={"recharge"}>Recharge</MenuItem>
            </Select>
          </FormControl>
          <LoadingButton
            size="small"
            sx={{ width: 240 }}
            startIcon={<ImportExportIcon />}
            variant="contained"
            loading={exporting}
            onClick={async () => {
              try {
                setExporting(true);
                const response = await axios.get(
                  `${API_ENDPOINT}/user/my-transactions-export`,
                  getHeader()
                );

                exportToExcel(response.data, "usage_history.xlsx");
              } catch (error) {
                toastError(error);
              } finally {
                setExporting(false);
              }
            }}
          >
            Export
          </LoadingButton>
        </Stack>
      </TitleActionsContainer>

      <TableContainer
        sx={{ mt: 1 }}
        component={Paper}
        variant="outlined"
        elevation={3}
      >
        <Table sx={{ minWidth: 650 }} aria-label="transaction history">
          <TableHead>
            <TableRow>
              <TableCell scope="col">SI.no.</TableCell>
              <TableCell scope="col">Message Id</TableCell>
              <TableCell scope="col">Type</TableCell>
              <TableCell scope="col" align="right">
                Amount
              </TableCell>
              <TableCell scope="col">Category</TableCell>
              <TableCell scope="col">Recipient</TableCell>
              <TableCell scope="col">Template</TableCell>
              <TableCell scope="col">Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.data.map((transaction, i) => (
              <TableRow
                key={transaction._id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{20 * (page - 1) + i + 1}</TableCell>
                <TableCell>{transaction._id}</TableCell>
                <TableCell>
                  <Chip
                    label={transaction.type}
                    color={transaction.type === "credit" ? "success" : "error"}
                    variant="outlined"
                  />
                </TableCell>
                <TableCell align="right">
                  <Typography
                    color={
                      transaction.type === "credit"
                        ? "success.main"
                        : "error.main"
                    }
                    fontWeight="bold"
                  >
                    {transaction.type === "credit" ? "+" : "-"}
                    {transaction.amount}
                  </Typography>
                </TableCell>
                <TableCell>{transaction.category}</TableCell>
                <TableCell>{transaction?.recipient ?? "NA"}</TableCell>
                <TableCell>{transaction?.templateName ?? "NA"}</TableCell>

                <TableCell>{formatDate(transaction.updatedOn)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {!data?.data?.length && (
        <Box m={4}>
          <Typography
            mt={4}
            textAlign={"center"}
            variant="h6"
            color={"GrayText"}
          >
            No transactions found
          </Typography>
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 2,
          alignItems: "center",
        }}
      >
        <Typography variant="caption">
          Total Items: {data.totalItems}
        </Typography>
        <Pagination
          count={data.totalPages}
          page={data.currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Box>
    </Container>
  );
};

export default TransactionHistory;
